import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { map, Observable, take } from 'rxjs';
import { FeatureFlagService } from '../feature-flag.service';
import { StorageService } from '../storage.service';
import { BaseService } from '..';

export const featureFlagGuardService: CanMatchFn = (
  route,
  state
): Observable<boolean | UrlTree> => {
    const featureFlagService = inject(FeatureFlagService); 
    const base = inject(BaseService);
    const router = inject(Router);

    const featureFlagKey = route?.data.featureFlagKey;
    featureFlagService.getFeatureFlagFromApi(featureFlagKey);

    return StorageService.featureFlagGuardTrigger.pipe(
        take(1),
        map(feature => {
            if (feature.key !== featureFlagKey || feature.state !== 'on' || !feature.variant) {
                base.modalService.presentFeatureUnavailable();
                router.navigate(["home"]);
                return false;
            }

            return true;
        })
    );
};